import { render } from "./ImpuestosComponent.vue?vue&type=template&id=7cd433e7"
import script from "./ImpuestosComponent.vue?vue&type=script&lang=js"
export * from "./ImpuestosComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__